import React, {useEffect, useRef, useState} from "react";
import { withRouter } from "react-router-dom";
import {useStyles} from "./styles/EvenWritingStyle";
import { Box, Button, Typography, IconButton, Select, MenuItem, FormControl } from "@material-ui/core";
import clsx from "clsx";
import { ReactComponent as ArrowDownIcon } from '../../../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as VolumeIcon } from '../../../../../common/images/VolumeIcon.svg';
import { ReactComponent as RefreshIcon } from '../../../../../common/images/RefreshIcon.svg';
import { ReactComponent as RefreshDisableIcon } from '../../../../../common/images/RefreshDisableIcon.svg';
import { ReactComponent as UploadIconB } from '../../../../../common/images/UploadIconB.svg';

import EduLangTabs from "../../../../../components/EduLangTabs";
import {inject, observer} from "mobx-react";
import TextField from "@material-ui/core/TextField";

function EvenStepFour(props) {
    const classes = useStyles();
    const [uploadSelectIndex, setUploadSelectIndex] = useState(0);

    const { contentStore, evenStepFourStore } = props;
    const { contentTapIndex, contentList } = evenStepFourStore;

    const imageRef = useRef(null);
    const fileInput = useRef(null);

    useEffect(() => {
        evenStepFourStore.getEvenStepFourContent(contentStore.stepValue, contentStore.dayValue);
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
            evenStepFourStore.initEvenStepFourContent(contentStore.stepValue, contentStore.dayValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSave = () => {
        evenStepFourStore.modifyEvenStepFourContent(contentStore.stepValue, contentStore.dayValue);
    }


    const handleTabChange = (event, newValue) => {
        evenStepFourStore.setContentTapIndex(newValue);
    }

    const handleChangeVoiceType = (voiceType, index) => {
        evenStepFourStore.setVoiceTypeByIndex(voiceType, index);
    }

    const handleChangeAudio = (voiceType, text, languageCode, index, isWord) => {
        contentStore.getGeneratedTTSWithAzure(languageCode, voiceType, text, (result) => evenStepFourStore.setWritingContentAudio(result, languageCode, index, isWord));
    }

    const handleChangeWritingText = (text, languageCode, index, isWord) => {
        evenStepFourStore.setWritingContentText(text, languageCode, index, isWord);
    }

    const onClickUploadButton = (index) => {
        setUploadSelectIndex(index);
        fileInput.current.click();
    }

    const onClickCreateImgButton = async (index, text) => {
        await contentStore.getGeneratedImage(text, (result) => evenStepFourStore.setImgFileByIndex(result, index));
    }

    const onClickGenerateSentence = (index, word, languageCode) => {
        contentStore.getGeneratedSentence(word, languageCode, (sentence) => evenStepFourStore.setWritingContentText(sentence, languageCode, index, false));
    }

    const onChangeUploadButton = (e) => {
        const originalFileName = e.target.files[0].name;
        if (e.target.files[0]) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                await evenStepFourStore.setImgFileByIndex(reader.result, uploadSelectIndex, originalFileName);
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    return (
        <div className={classes.root}>
            <Box className={clsx(classes.boxWrap, classes.heightStep1)}>
                <EduLangTabs value={contentTapIndex} handleChange={handleTabChange}/>
                {!!contentList.length && contentList.map((content, i) => {
                    const languageCode = evenStepFourStore.getSelectedLangCode();
                    const selectedContent = content.contents.filter(c => c.languageCode === languageCode)[0];
                    return (
                        <Box className={classes.textBox} key={i}>
                            <Box display={'flex'} justifyContent={'space-between'} sx={{borderBottom: '1px solid #bcbcbc'}}>
                                <Box display={'flex'} justifyContent={'flex-start'} alignItems={'baseline'}>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={selectedContent.voiceType}
                                            onChange={(e) => handleChangeVoiceType(e.target.value, i)}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className: classes.selectPopover
                                            }}
                                            // onBlur={this.handleDomainBoxFocusOut2}
                                        >
                                            <MenuItem value='Man'>성인남성</MenuItem>
                                            <MenuItem value='Woman'>성인여성</MenuItem>
                                            <MenuItem value='Child'>아이</MenuItem>
                                            <MenuItem value='Elderly'>노인</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Box>
                                        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
                                            <Box className={classes.iconBtnSet}>
                                                {selectedContent.audioExist ?
                                                    <IconButton disableRipple>
                                                        <RefreshDisableIcon />
                                                    </IconButton> :
                                                    <IconButton disableRipple onClick={() => handleChangeAudio(selectedContent.voiceType, selectedContent.word, selectedContent.languageCode, i, true)}>
                                                        <RefreshIcon/>
                                                    </IconButton>
                                                }
                                            </Box>
                                            <Box>
                                                <Box className={classes.textListBox}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth
                                                        onChange={(e) => handleChangeWritingText(e.target.value, selectedContent.languageCode, i, true)}
                                                        placeholder={'단어를 입력해주세요.'}
                                                        value={selectedContent.word}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                    <IconButton
                                                        className={classes.volumeIconButton}
                                                        onClick={() => evenStepFourStore.playAudio(selectedContent.audio, `${selectedContent.languageCode}-word-${content.sequence}`)}
                                                        disableRipple>
                                                        <VolumeIcon/>
                                                        {/*<VolumeDisableIcon />*/}
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
                                            <Box className={classes.iconBtnSet}>
                                                {selectedContent.descriptionAudioExist ?
                                                    <IconButton disableRipple>
                                                        <RefreshDisableIcon />
                                                    </IconButton> :
                                                    <IconButton disableRipple onClick={() => handleChangeAudio(selectedContent.voiceType, selectedContent.description, selectedContent.languageCode, i, false)}>
                                                        <RefreshIcon/>
                                                    </IconButton>
                                                }
                                            </Box>
                                            <Box>
                                                <Box className={classes.textListBox}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth
                                                        onChange={(e) => handleChangeWritingText(e.target.value, selectedContent.languageCode, i, false)}
                                                        placeholder={'문장을 입력해주세요.'}
                                                        value={selectedContent.description}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                    <IconButton
                                                        className={classes.volumeIconButton}
                                                        onClick={() => evenStepFourStore.playAudio(selectedContent.descriptionAudio, `${selectedContent.languageCode}-description-${content.sequence}`)}
                                                        disableRipple>
                                                        <VolumeIcon/>
                                                        {/*<VolumeDisableIcon />*/}
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className={clsx(classes.disableButtonStyle, classes.activeButtonStyle)}>
                                        <Button disableRipple onClick={() => onClickGenerateSentence(i, selectedContent.word, selectedContent.languageCode)}>
                                            <Typography>문장 생성</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                                <Box>
                                    <Box className={classes.imgContainer}>
                                        <img ref={imageRef}
                                             src={`data:image/png;base64,${content.image}`}
                                             alt={`writing-${content.contentId}`}
                                             style={{maxWidth: '631px'}}
                                        />
                                    </Box>
                                    <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}
                                         className={classes.imgButtonGroup}>
                                        <IconButton disableRipple onClick={() => onClickCreateImgButton(i, selectedContent.word)}>
                                            <RefreshIcon/>
                                            {/*<RefreshDisableIcon />*/}
                                        </IconButton>
                                        <IconButton disableRipple onClick={() => onClickUploadButton(i)}>
                                            <UploadIconB/>
                                        </IconButton>
                                        <input type="file"
                                               ref={fileInput}
                                               accept="image/*"
                                               onChange={onChangeUploadButton}
                                               style={{display: "none"}}/>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )})}
            </Box>
        </div>
    );
}

export default withRouter(inject('contentStore','evenStepFourStore')(observer(EvenStepFour)));
